module.exports = __webpack_public_path__ + "img/img48.05075624.svg";